import {Col, Container, Row,ButtonGroup,Button} from 'react-bootstrap'
// import me from 'images/me.png'
import me from './images/me.PNG';
import Introduction from './components/introduction';
import Workexperience from './components/workexperience';
import Spacer from './components/spacer';
import Projects from './components/projects';
import Activities from './components/activities';
import {useMatomo} from '@datapunt/matomo-tracker-react'
import { useEffect } from 'react';

function App() {

  const {trackPageView, trackEvent} = useMatomo();
  useEffect(()=>{
    trackPageView()
  },[])
  return (
    <Container fluid>
      <Row>
        <Col xs={12} sm={5} md={4} style={{height:"100vh"}}>
          <div style={{textAlign:"left",marginLeft:"7vw",color:"gray"}}>
            <div style={{paddingTop:"2vw",paddingBottom:"10px",color:"darkslategray"}}><h2>Binay Gurung</h2></div>
            <img src={me} height="480" alt="me"/>
            <div style={{paddingTop:"10px"}}>Undergraduate Student at HKUST</div>
            <div >Majoring in Computer Engineering</div>

            <div style={{paddingTop:"10px"}}>
              <ButtonGroup style={{borderColor:"f4f4f4"}}>
                <Button variant="outline-secondary" href="http://www.cpeg.ust.hk" target="_blank">
                  <div style={{verticalAlign:"middle",display:"grid",gridAutoFlow:"row",width:65}}>
                      <span style={{fontSize:"11px"}}>Department</span>
                      <strong style={{fontSize:"13px"}}>CPEG</strong>
                  </div>
                </Button>
                <Button variant="outline-secondary" href="http://www.ust.hk" target="_blank">
                  <div style={{verticalAlign:"middle",display:"grid",gridAutoFlow:"row",width:65}}>
                  <span style={{fontSize:"11px"}}>University</span>
                      <strong style={{fontSize:"13px"}}>HKUST</strong>
                  </div>
                </Button>
                <Button variant="outline-secondary" href="http://www.github.com/itsbinay" target="_blank">
                  <div style={{verticalAlign:"middle",display:"grid",gridAutoFlow:"row",width:65}}>
                  <span style={{fontSize:"11px"}}>Projects</span>
                      <strong style={{fontSize:"13px"}}>Github</strong>
                  </div>
                </Button>
              </ButtonGroup>
            </div>
          </div>
        </Col>
        <Col xs={12} sm={7} md={8} style={{overflow:"scroll",height:"100vh"}}>
            <div style={{textAlign:"left",marginLeft:"7vw",color:"gray",marginRight:"30px"}}>
              <div style={{paddingTop:"2vw",paddingBottom:"10px",color:"darkslategray"}}><h2>Hi, Binay here!</h2></div>
              <Introduction/>
              <Spacer size={20}/>
              <Workexperience/>
              <Spacer size={20}/>
              <Activities/>
              <Spacer size={20}/>
              <Spacer size={80}/>
            </div>
        </Col>
      </Row>
    </Container>
  );
}

export default App;
